import state from './state'
import getter from './getters'
import mutations from './mutations'
import actions from './actions'
import detail from './detail'
import coupons from './coupons'
import pay from './pay'
import activities from './activities'
import common from './common'

export default {
  modules: {
    pay,
    detail,
    coupons,
    activities,
    common,
  },
  strict: false,
  state,
  getter,
  mutations,
  actions,
}
